export default __webpack_public_path__ + "static/voicerightplain-626ea3a62d35fd47981b17919e08c98c.svg";